import { Suspense } from "react";
import { lazyPage } from "../../lib/lazyPage.js";
import { DesktopMailSkeleton } from "../../components/DesktopSkeletons.js";

/** /mail and its folder, message and search routes on a desktop. A phone
 *  never reaches this: App mounts the phone app (src/phone) instead of the
 *  desktop routes. Lazy, so the seven-thousand-line mail page is its own
 *  chunk behind a list-shaped placeholder. */
const DesktopMailLazy = lazyPage(() => import("../../pages/Mail.js").then((m) => ({ default: m.Mail })));

export function MailRoute(): JSX.Element {
  return (
    <Suspense fallback={<DesktopMailSkeleton />}>
      <DesktopMailLazy />
    </Suspense>
  );
}
